/**
 * 多维分析和号码包提取页面的 添加数据源模态框的文本配置
 */
export default {
  dbl_dataSource_step_one_title: "选择数据表",
  dbl_dataSource_step_two_title: "设置关联关系",
  dbl_dataSource_step_there_title: "选择图表类型",
  dbl_dataSource_first_level: "一级类目",
  dbl_dataSource_second_level: "二级类目",
  dbl_dataSource_search_placeholder: "搜索表名、表描述、字段名或管理员",
  dbl_dataSource_table_name: "名称",
  dbl_dataSource_table_description: "描述",
  dbl_dataSource_table_cycle: "表周期",
  dbl_dataSource_usage_count: "使用次数",
  dbl_dataSource_table_database: "数据库类型",
  dbl_dataSource_database_name: "数据库名称",
  dbl_dataSource_self_join: "自关联",
  dbl_dataSource_self_join_des: "描述",
  dbl_dataSource_self_join_demo: "示例",
  dbl_dataSource_joining_field: "关联字段",
  dbl_dataSource_add: "添加",
  dbl_dataSource_delete: "删除",
  dbl_dataSource_next_step: "下一步",
  dbl_dataSource_prev_step: "上一步",
  dbl_dataSource_preview_data: "预览数据",
  dbl_dataSource_submit: "提交",
  dbl_dataSource_auto_create: "自动创建报表",
  dbl_dataSource_create_table: "创建空白报表",
	
  // 添加数据源后, 页面显示相关文本
  dbl_dataSource_public: "公共",
  dbl_dataSource_dimension: "维度",
  dbl_dataSource_metric: "指标",
	
  dbl_dataSource_more_then_three: "最多选3个，请取消再选择",
  dbl_dataSource_not_same: "不是相同数据源不能联表",
	
  dbl_dataSource_left_join: "左关联",
  dbl_dataSource_right_join: "右关联",
  dbl_dataSource_inner_join: "内连接",
  dbl_dataSource_full_join: "全连接",
	
  dbl_dataSource_relation_select: "关联字段选择",
  dbl_dataSource_relation_search: "搜索关联字段",
  dbl_dataSource_relation_not_match: "关联字段类型不匹配",
  dbl_dataSource_relation_select_info: "请选择关联字段",
	
  dbl_dataSource_tooltip: "系统表信息与数据库表信息不符，请联系数据同学与lynnhong进行校验",
  dbl_dataSource_sql_step_one_title: "SQL 编辑",
  dbl_dataSource_sql_step_two_title: "SQL 保存",
	
  dbl_dataSource_self_join_success: "成功自关联",
  dbl_dataSource_add_table: "成功添加数据表",
  dbl_dataSource_join_table: "成功关联{count}个数据表",
  
  dbl_dataSource_confirm_replace_title: "确认替换数据源？",
  dbl_dataSource_confirm_replace_info: "您已更换数据源。所有匹配的字段（筛选器、维度、指标）均已被保留。<br/>" +
    "注意：未匹配的字段将从操作区中移除，包括筛选器、维度和指标。",
};